const selectors = {
  parallaxContainer: ".parallax-container",
  html: "html",
  slider: ".snap-slider",
  slides: ".snap-slider__slides",
  slide: ".snap-slide",
  dots: ".snap-slider__dots",
  dot: ".snap-slider__dot",
  next: ".snap-slide__bottom",
};

const browsers = {
  CHROME: "chrome",
  SAFARI: "safari",
  FIREFOX: "firefox",
  EDGE: "edge",
};

class Parallax extends HTMLElement {
  scrollToTarget = (top) => {
    // Using mostly-okay-on-modern-devices-now scroll() method, instead of the previous jQuery implementation
    scroll({
      top,
      behavior: "smooth",
    });
  };

  constructor() {
    super();

    this.elements = this.getElements();
    if (Object.keys(this.elements).length === 0) return;
    this.windowWidth = window.innerWidth;
    this.mobile = this.windowWidth < 750;
    this.browserName = navigator.userAgent.toLowerCase();
    this.browser = browsers.CHROME;
    this.noSnapSupport = false;
    if (
      this.browserName.includes(browsers.SAFARI) &&
      !this.browser.includes(browsers.CHROME)
    ) {
      this.browser = browsers.SAFARI;
      this.noSnapSupport = true;
    } else if (this.browser.includes(browsers.FIREFOX)) {
      this.browser = browsers.FIREFOX;
    } else if (this.browser.includes(browsers.EDGE)) {
      this.browser = browsers.EDGE;
      this.noSnapSupport = true;
    }
    this.observerOptions = this.getObserverOptions();
    this.setupEventListeners();

    // initial
    this.addBrowserClass();
    this.setDots();
    this.setMobileCarousel({ resetImages: true });
    this.snapAlways();
    if (this.noSnapSupport) {
      this.snapPolyfill();
    } else {
      this.snapStandard();
    }

    // set clickable slider elements
    this.setClickable();
  }

  addBrowserClass() {
    this.elements.html.classList.add(`browser--${this.browser}`);
  }

  debounce(func, wait, immediate) {
    let timeout;
    return function executedFunction({ ...args }) {
      // eslint-disable-next-line @babel/no-invalid-this,consistent-this
      const context = this;

      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      const callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // covering chrome mobile issues with resize triggering on scroll
  isWidthResize() {
    return window.innerWidth !== this.windowWidth;
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    let currentElement = element;
    while (currentElement) {
      offsetTop += currentElement.offsetTop;
      currentElement = currentElement.offsetParent;
    }
    return offsetTop;
  }

  blockScroll(block) {
    if (block) {
      const scrollBarGap =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (scrollBarGap > 0) {
        document.body.style.paddingRight = `${scrollBarGap}px`;
        this.elements.dots.style.paddingRight = `${scrollBarGap}px`;
      }
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px";
      this.elements.dots.style.paddingRight = `0px`;
    }
  }

  setMobileCarousel({ resetImages }) {
    // document.querySelector('.snap-slider__slides.slick-slider').slick('unslick');
    // if (window.innerWidth < 812) {
    //     document.querySelector('.snap-slider__slides').slick({
    //         arrows: false,
    //         dots: true,
    //         infinite: false
    //     });
    // }

    if (window.innerWidth <= 750) {
      // eslint-disable-next-line no-undef
      this.swiper = new Swiper(".swiper", {
        // Optional parameters
        // direction: 'horizontal',
        // mousewheel: true,
        // loop: true,

        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction",
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        
        // // And if we need scrollbar
        // scrollbar: {
        //     el: '.swiper-scrollbar',
        // },
      });
    }
    // for crash between with background lazyload and slick carousel
    if (resetImages) {
      const targets = Array.from(document.querySelectorAll("[data-bg]"));
      for (const target of targets) {
        const bg = target.getAttribute("data-bg");
        if (bg) {
          target.style.backgroundImage = `url(${bg})`;
        }
      }

      const targets_mobile = Array.from(
        document.querySelectorAll("[data-bg-mobile]")
      );
      for (const target_mobile of targets_mobile) {
        const bg_mobile = target_mobile.getAttribute("data-bg-mobile");
        if (bg_mobile) {
          target_mobile.style.backgroundImage = `url(${bg_mobile})`;
        }
      }
    }
  }

  getObserverOptions() {
    return this.mobile
      ? {
          threshold: 1,
          rootMargin: "15% 0px 0px 0px",
        }
      : {
          threshold: 1 / this.elements.slidesArr.length,
        };
  }

  sliderObserver(intersecting, notIntersecting) {
    if (!this.elements.slidesArr.length || !this.elements.slider) return;

    const callback = (entries) => {
      for (const entry of entries) {
        if (
          entry.intersectionRatio.toFixed(4) ===
          this.observerOptions.threshold.toFixed(4)
        ) {
          intersecting();
        } else {
          notIntersecting();
        }
      }
    };
    let observer = new IntersectionObserver(callback, this.observerOptions);
    observer.observe(this.elements.slider);
    window.addEventListener("resize", async () => {
      await observer.unobserve(this.elements.slider);
      await observer.disconnect();
      this.observerOptions = this.getObserverOptions();
      // eslint-disable-next-line require-atomic-updates
      observer = new IntersectionObserver(callback, this.observerOptions);
      observer.observe(this.elements.slider);
    });
  }

  snapAlways() {
    this.elements.html.classList.add("template-our-history");
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }

  snapStandard() {
    this.sliderObserver(
      () => {
        this.toggleHtmlSnap(true);
      },
      () => {
        this.toggleHtmlSnap(false);
      }
    );
  }

  snapPolyfill() {
    this.elements.html.classList.add("template-our-history--snap-polyfill");
    this.sliderObserver(
      () => {
        this.elements.html.classList.add(
          "template-our-history--snap-polyfill-mandatory"
        );
      },
      () => {
        this.elements.html.classList.remove(
          "template-our-history--snap-polyfill-mandatory"
        );
      }
    );
  }

  toggleHtmlSnap(enable = false) {
    if (enable) {
      this.elements.html.classList.add("template-our-history--scroll-snap");
    } else {
      this.elements.html.classList.remove("template-our-history--scroll-snap");
    }
  }

  setClickable() {
    for (let i = 0; i < this.elements.dotsArr.length; i++) {
      this.elements.dotsArr[i].addEventListener("click", () => {
        const offsetTop = this.getOffsetTop(this.elements.slidesArr[i]);
        this.scrollToTarget(offsetTop);
      });
    }
    for (let i = 0; i < this.elements.nextsArr.length; i++) {
      this.elements.nextsArr[i].addEventListener("click", () => {
        const offsetTop = this.getOffsetTop(this.elements.slidesArr[i + 1]);
        this.scrollToTarget(offsetTop);
      });
    }
  }

  setActive({ windowHeight, top }) {
    const currentSlide = Math.round(Math.abs(top) / windowHeight);
    for (let i = 0; i < this.elements.dotsArr.length; i++) {
      if (i === currentSlide) {
        this.elements.dotsArr[i].classList.add("snap-slider__dot--active");
      } else {
        this.elements.dotsArr[i].classList.remove("snap-slider__dot--active");
      }
    }
  }

  setDots() {
    if (this.mobile) return;

    const { top, bottom } = this.elements.slides.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const sliderBelowView = bottom >= windowHeight;
    const sliderAboveView = top <= 0;
    const sliderInView = sliderBelowView && sliderAboveView;
    if (sliderInView) {
      this.debounce(this.setActive({ windowHeight, top }), 50, true);
    }
  }

  getElements() {
    const container = document.querySelector(selectors.parallaxContainer);
    return container
      ? {
          container,
          html: document.querySelector(selectors.html),
          slider: container.querySelector(selectors.slider),
          slides: container.querySelector(selectors.slides),
          slidesArr: container.querySelectorAll(selectors.slide),
          dots: container.querySelector(selectors.dots),
          dotsArr: container.querySelectorAll(selectors.dot),
          nextsArr: container.querySelectorAll(selectors.next),
        }
      : {};
  }

  setupEventListeners() {
    // on scroll
    window.addEventListener("scroll", this.setDots.bind(this));
    // optional on resize
    window.addEventListener("resize", this.setDots.bind(this));
    window.addEventListener("resize", () => {
      if (this.isWidthResize()) {
        this.setMobileCarousel({ resetImages: true });
      }
    });
  }
}

customElements.define("parallax-slider", Parallax);
